import {useComponentsTheme} from 'platform/components';

import {useEffect, useRef} from 'react';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {calculateTimePosition} from '../utils/calculateTimePosition';

export function CurrentTimeIndicator(props: RequiredTestIdProps) {
  const theme = useComponentsTheme();
  const currentTime = useRef(new Date());

  /**
   * Updates the current time every 3.33 minutes (200000ms)
   * Creates an interval that updates the currentTime ref with the new Date
   * Cleans up the interval when component unmounts
   */
  useEffect(function tickCurrentTime() {
    const timer = setInterval(() => {
      currentTime.current = new Date();
    }, UPDATE_INTERVAL);

    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="pointer-events-none absolute right-[-3px] left-0 h-0 border-t-2 border-[var(--color-palettes-red-60-100)] before:absolute before:-top-[7px] before:-left-[10px] before:h-3 before:w-3 before:rounded-full before:bg-[var(--color-palettes-red-60-100)] before:content-['']"
      style={{
        top: calculateTimePosition(currentTime.current),
        zIndex: theme.zIndices.BIG_CALENDAR_CURRENT_TIME_INDICATOR,
      }}
      data-testid={suffixTestId('currentTimeIndicator', props)}
    />
  );
}

const UPDATE_INTERVAL = 200000; // 3.33 minutes
